export default __webpack_public_path__ + "static/media/goshen11.9a29796d.jpg";